import { Component, inject } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { IMapTileDefinition } from '../../../dashboards/interfaces/tiles/definitions/map-tile-definition.interface';
import { TileCreatorService } from '../../services/tile-creator.service';
import { TILE_REQUEST } from '../../tokens/tile-request.token';
import { TileSetupWizardComponent } from '../tile-setup-wizard.component';

@Component({
  standalone: false,
  selector: 'app-map-setup-wizard',
  templateUrl: './map-setup-wizard.component.html',
  styleUrls: ['./map-setup-wizard.component.scss'],
})
export class MapSetupWizardComponent extends TileSetupWizardComponent<IMapTileDefinition> {
  dataSourceObject;

  get titleControl(): AbstractControl {
    return this.setupForm.get('title') as AbstractControl;
  }

  get dataSourceControl(): AbstractControl {
    return this.setupForm.get('dataSource') as AbstractControl;
  }

  constructor(
    private readonly fb: FormBuilder,
    private readonly tileCreatorService: TileCreatorService,
  ) {
    super();

    this.tileInstance = inject(TILE_REQUEST).tileInstance;
  }

  ngOnInit() {
    this.initSetupForms();

    this.hookForm();
  }

  initSetupForms() {
    this.setupForm = this.fb.group({
      title: ['', [Validators.required]],
      dataSource: ['', [Validators.required]],
    });

    if (this.tileInstance) {
      this.setupForm.patchValue({
        title: this.tileInstance.title,
        dataSource: this.tileInstance.recipe.dataSource,
      });
    }
  }

  initDataSource(dataSource: any) {
    this.dataSourceObject = dataSource;
  }

  onCreate() {
    Object.assign(this.tileInstance, this.getChanges());
    this.tileCreatorService.onChange.next();
  }

  getChanges() {
    return {
      tileType: 'map',
      title: this.titleControl.value,
      recipe: {
        dataSource: this.dataSourceControl.value,
      },
      canView: 'true',
      mapOptions: {
        canScroll: true,
      },
    };
  }
}
